// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_ZhI","cls2":"AppsMegaMenu-cls2_uKI AppsMegaMenu-cls1_ZhI"};